var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._t("default"),_vm._v(" "),_c('span',{staticClass:"copy",on:{"click":function($event){$event.stopPropagation();return _vm.copyText(_vm.text)}}},[_vm._v("Copy")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }